import { useEffect, useState } from 'react';
import { Row, Col, Tab, Tabs } from 'react-bootstrap';
import AdditionalFields from './PersonalIdentificationAdditionalFields';
import FindMyAccount from './PersonalIdentificationFindMyAccount';
import { ClaimDetailsSVG } from '../../../img/GlobalSVG';

const PersonalIdentification = (props) => {
  //const { onChange } = props;
  const { values, errorValidation, hasEditPermission } = props;
  const { personalIdentificationEditable, waysOfReg } = props;
  const [memberKey, setMemberKey] = useState('For Member ID');
  const [memberKeyTab, setMemberKeyTab] = useState('For Member');
  const [dependentKey, setDependentKey] = useState('For Member ID');

  useEffect(() => {
    if (values.allowMember === true) {
      setMemberKeyTab('For Member');
    } else {
      setMemberKeyTab('For Dependent');
    }
    if (waysOfReg[1] === true) {
      setMemberKey('For Member ID');
    } else {
      setMemberKey('For “Find my account”');
    }

    if (waysOfReg[4] === true) {
      setDependentKey('For Member ID');
    } else {
      setDependentKey('For “Find my account”');
    }
  }, [waysOfReg, values]);

  return (
    <Row className="Payment-details personal-identification">
      <Col className="pl-0">
        <h3
          className={
            errorValidation.personalIdentityMemberMemberID ||
            errorValidation.personalIdentityMemberUserInfo ||
            errorValidation.personalIdentityDependentMemberID ||
            errorValidation.personalIdentityDependentUserInfo ||
            errorValidation.memberMinField ||
            errorValidation.dependentMinField
              ? 'errorValidate'
              : ''
          }
        >
          Personal Identification
        </h3>
        <p>
          Define the Personal Identification fields for the various ways of
          Member and Dependent registration that you have selected above.{' '}
        </p>
        <p className="mb-2">
          1. For Member ID, a minimum of 3 and a maximum of 10 fields can be
          selected.
          <br></br>
          2. The number of minimum required fields for Find My Account is
          configurable. A maximum of 12 fields can be selected.
        </p>
        <p className="mb-2 identification-note">
          {`Note: For "Find My Account" , if you do not select the minimum
          required fields from the list, you will not be able to save your
          changes. (For example: if you enter minimum required fields as 3, you
          will have to select 3 required fields from the list.)`}
        </p>
        {errorValidation.personalIdentityMemberMemberID ||
        errorValidation.personalIdentityMemberUserInfo ||
        errorValidation.personalIdentityDependentMemberID ||
        errorValidation.personalIdentityDependentUserInfo ? (
          <div className="d-flex align-items-center">
            <ClaimDetailsSVG.ExclamationSVG />
            <p className="errorMessage ml-2">
              {' '}
              Minimum required fields criteria not met. Add the required
              fields(s) and try again.
            </p>
          </div>
        ) : errorValidation.memberMinField ||
          errorValidation.dependentMinField ? (
          <div className="d-flex align-items-center">
            <ClaimDetailsSVG.ExclamationSVG />
            <p className="errorMessage ml-2">Entered value is not valid</p>
          </div>
        ) : null}
      </Col>
      <Col className="setup-form">
        {(values.allowDependent || values.allowMember) && (
          <Tabs
            activeKey={memberKeyTab}
            onSelect={(k) => setMemberKeyTab(k)}
            id="uncontrolled-tab-example"
            className={`${
              (errorValidation.personalIdentityMemberMemberID ||
                errorValidation.personalIdentityMemberUserInfo ||
                errorValidation.memberMinField) &&
              'errorValidateForMember '
            }
          ${
            (errorValidation.personalIdentityDependentMemberID ||
              errorValidation.personalIdentityDependentUserInfo ||
              errorValidation.dependentMinField) &&
            ' errorValidateForDependent'
          }`}
          >
            {values.allowMember && (
              <Tab eventKey="For Member" title="For Member">
                <div className="reg-form-activation">
                  <Tabs
                    activeKey={memberKey}
                    onSelect={(k) => setMemberKey(k)}
                    id="reg-form-activation"
                    className={`${
                      errorValidation.personalIdentityMemberMemberID &&
                      'errorValidateForMemberMemberID '
                    }
              ${
                (errorValidation.personalIdentityMemberUserInfo ||
                  errorValidation.memberMinField) &&
                ' errorValidateForMemberUserInfo '
              }`}
                  >
                    {/*<Tab
                eventKey="For Activation code"
                title="For Activation code"
                className="tab-activation reg-form-activation"
              >
                <AdditionalFields iIndex={0}/>
              </Tab> */}
                    {waysOfReg[1] && (
                      <Tab eventKey="For Member ID" title="For Member ID">
                        <AdditionalFields
                          iIndex={1}
                          personalIdentificationEditable={
                            personalIdentificationEditable
                          }
                          hasEditPermission={hasEditPermission}
                        />
                      </Tab>
                    )}
                    {waysOfReg[2] && (
                      <Tab
                        eventKey="For “Find my account”"
                        title="For “Find my account”"
                      >
                        <FindMyAccount
                          iIndex={2}
                          personalIdentificationEditable={
                            personalIdentificationEditable
                          }
                          memberMinField={errorValidation.memberMinField}
                          hasEditPermission={hasEditPermission}
                        />
                      </Tab>
                    )}
                  </Tabs>
                </div>
              </Tab>
            )}
            {values.allowDependent && (
              <Tab eventKey="For Dependent" title="For Dependent">
                <div className="reg-form-activation">
                  <Tabs
                    activeKey={dependentKey}
                    onSelect={(k) => setDependentKey(k)}
                    id="reg-form-activation"
                    className={`${
                      errorValidation.personalIdentityDependentMemberID &&
                      'errorValidateForDependentMemberID '
                    }
              ${
                (errorValidation.personalIdentityDependentUserInfo ||
                  errorValidation.dependentMinField) &&
                ' errorValidateForDependentUserInfo'
              }`}
                  >
                    {/*<Tab
                eventKey="For Activation code"
                title="For Activation code"
                className="tab-activation reg-form-activation"
              >
                <AdditionalFields iIndex={3}/>
              </Tab> */}
                    {waysOfReg[4] && (
                      <Tab eventKey="For Member ID" title="For Member ID">
                        <AdditionalFields
                          iIndex={4}
                          personalIdentificationEditable={
                            personalIdentificationEditable
                          }
                          hasEditPermission={hasEditPermission}
                        />
                      </Tab>
                    )}
                    {waysOfReg[5] && (
                      <Tab
                        eventKey="For “Find my account”"
                        title="For “Find my account”"
                      >
                        <FindMyAccount
                          iIndex={5}
                          personalIdentificationEditable={
                            personalIdentificationEditable
                          }
                          dependentMinField={errorValidation.dependentMinField}
                          hasEditPermission={hasEditPermission}
                        />
                      </Tab>
                    )}
                  </Tabs>
                </div>
              </Tab>
            )}
          </Tabs>
        )}
        {!values.allowDependent && !values.allowMember && (
          <p className="mt-4">
            Member and Dependent are not allowed to register.
          </p>
        )}
      </Col>
    </Row>
  );
};

export default PersonalIdentification;
